import { Paper, Stack } from '@mui/material'
import SettingsToggle from '@/components/Settings/SettingsToggle'
import { PreferenceFloatingSelect } from '@/components/Settings/SettingsPreferenceSection'
import { settingsRowPaperClassName } from '@/components/Settings/settingsPaperGroup'
import { SettingsRowLabelBlock } from '@/components/Settings/settingsRowLabelBlock'
import shared from '@/components/Settings/settingsShared.module.scss'

/**
 * @param {{
 *   row: { id: string, title: string, description?: string, control: string, stateKey: string, options?: { value: string, label: string }[] },
 *   groupPosition: string, compactY: boolean,
 *   values: Record<string, boolean | string>,
 *   setValues: React.Dispatch<React.SetStateAction<Record<string, boolean | string>>>,
 * }} props
 */
export function SiaAssistantPreferenceRow({ row, groupPosition, compactY, values, setValues }) {
  const v = values[row.stateKey]
  return (
    <Paper key={row.id} elevation={0} className={settingsRowPaperClassName({ groupPosition, compactY })}>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" className={shared.preferenceRowLayout}>
        <SettingsRowLabelBlock title={row.title} description={row.description} hideDescription={compactY && row.id !== 'keyboard-shortcut'} />
        {row.control === 'toggle' ? <SettingsToggle checked={Boolean(v)} onChange={(next) => setValues((s) => ({ ...s, [row.stateKey]: next }))} aria-label={row.title} /> : null}
        {row.control === 'dropdown' && row.options ? (
          <PreferenceFloatingSelect aria-label={row.title} value={typeof v === 'string' ? v : ''} options={row.options} onChange={(next) => setValues((s) => ({ ...s, [row.stateKey]: next }))} />
        ) : null}
      </Stack>
    </Paper>
  )
}
